
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetQuery from "./helper/useGetQuery"
import useUpdateMutation from "./helper/useUpdateMutation"
import useUpdateMutationById from "./helper/useUpdateMutationById";

  const API = {
    GET: "/api/admin/social_media",
    ADD: "/api/admin/social_media",
    UPDATE: "/api/admin/social_media",
    DELETE: "/api/admin/social_media",
  };

  const KEY = "SOCIALMEDIA";
  export const useGetSocialMedia = (params?:any) => useGetQuery(KEY, API.GET, params);
  export const useAddSocialMedia = () => useAddMutation(KEY, API.ADD);
  export const useUpdateSocialMedia = () => useUpdateMutationById(KEY, API.UPDATE);
  export const useDeleteSocialMedia = () =>useDeleteMutation(KEY, API.DELETE);
